import * as angular from "angular";
import * as _ from "lodash";
import {CustomerType} from "../angular/types/customer-type.type";
import {AddressesService} from "../../addresses/services/addresses-service.factory";
import {SitesRequestsService} from "../../sites/services/sites-requests.service";

export class CustomersDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private $log, private splitService,
              private $filter, private $branches, private sitesRequestsService: SitesRequestsService,
              private addressesService: AddressesService) {
  }

  createCustomer(event, customer?, relatedAccountId?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-customer-dialog.html').default,
      controller: function ($scope) {

        const country = self.splitService.getCountryCode(),
          siteId = self.splitService.getSiteId(),
          PhoneFormat = require('phoneformat.js');

        $scope.customAddressEnabled = false;
        $scope.customerType = CustomerType;
        $scope.customerTypeOptions = Object.values(CustomerType);

        $scope.customer = {
          firstName: _.get(customer, 'contact.name'),
          lastName: undefined,
          businessName: _.get(customer, 'contact.businessName'),
          type: CustomerType.Business,
          phone: _.get(customer, 'contact.phoneNo'),
          email: _.get(customer, 'contact.email'),
          additionalPhone: _.get(customer, 'contact.additionalPhone') || _.get(customer, 'contact.additionalPhoneNo'),
          addresses: []
        };


        $scope.relatedAccountId = relatedAccountId;
        if (relatedAccountId) {
          $scope.customer.accountIds = [relatedAccountId];
        }


        $scope.address = _.get(customer, 'address') || _.get(customer, 'location.address');

        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        //        Public methods
        // ******************************

        $scope.onPhoneChanged = (form) => {
          if (!!$scope.customer.phone) {
            $scope._phoneValidation($scope.customer.phone)
              .then((res) => {
                form.phone.$setValidity('valid', res.isValid);
              })
              .catch((error) => {
                form.phone.$setValidity('valid', false);
              })
          } else {
            form.phone.$setValidity('valid', false);
          }
        }

        $scope.onToggleCustomAddress = () => {
          $scope.customAddressEnabled = !$scope.customAddressEnabled;
        }

        $scope.onAdditionalPhoneChanged = (phone, form) => {
          $scope.customer.additionalPhone = phone;
          if (!!$scope.customer.additionalPhone) {
            $scope._phoneValidation($scope.customer.additionalPhone)
              .then((res) => {
                form.additionalPhone.$setValidity('valid', res.isValid);
              })
              .catch((error) => {

              })
          }
        }

        $scope._phoneValidation = (phone) => {
          return self.sitesRequestsService.validatePhoneNumber(siteId, phone, country);
        }

        $scope.onAddressChange = (address) => {
          $scope.address = address;
        }

        $scope.onLocationSelect = (location) => {
          if (!$scope.address) {
            $scope.address = {}
          }
          $scope.address.location = self.addressesService.getAddressLocation(location.lat, location.lng);
        }

        $scope.onAccountsChange = (ids) => {
          $scope.customer.accountIds = ids;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              $scope.customer.phone = self.$filter('bringozPhonePrefix')($scope.customer.phone);
              $scope.customer.additionalPhone = self.$filter('bringozPhonePrefix')(_.get($scope.customer, 'additionalPhone'));
              $scope.customer.addresses.push($scope.address);
              self.$mdDialog.hide($scope.customer);
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editCustomer(event, customer) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-customer-dialog.html').default,
      controller: function ($scope) {

        const country = self.splitService.getCountryCode(),
          siteId = self.splitService.getSiteId(),
          PhoneFormat = require('phoneformat.js');

        $scope.customerType = CustomerType;
        $scope.customerTypeOptions = Object.values(CustomerType);

        $scope.customer = angular.copy(customer);
        $scope.customer.phone = self.$filter('bringozPhone')($scope.customer.phone);
        $scope.customer.additionalPhone = self.$filter('bringozPhone')(_.get($scope.customer, 'additionalPhone'));

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onPhoneChanged = (form) => {
          if (!!$scope.customer.phone) {
            $scope._phoneValidation($scope.customer.phone)
              .then((res) => {
                form.phone.$setValidity('valid', res.isValid);
              })
              .catch((error) => {
                form.phone.$setValidity('valid', false);
              })
          } else {
            form.phone.$setValidity('valid', false);
          }
        }

        $scope.onAdditionalPhoneChanged = (phone, form) => {
          $scope.customer.additionalPhone = phone;
          if (!!$scope.customer.additionalPhone) {
            $scope._phoneValidation($scope.customer.additionalPhone)
              .then((res) => {
                form.additionalPhone.$setValidity('valid', res.isValid);
              })
              .catch((error) => {

              })
          }
        }

        $scope._phoneValidation = (phone) => {
          return self.sitesRequestsService.validatePhoneNumber(siteId, phone, country);
        }

        $scope.onAccountsChange = (accountIds) => {
          $scope.customer.accountIds = accountIds;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              $scope.customer.phone = self.$filter('bringozPhonePrefix')($scope.customer.phone);
              $scope.customer.additionalPhone = self.$filter('bringozPhonePrefix')(_.get($scope.customer, 'additionalPhone'));

              self.$mdDialog.hide($scope.customer);
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  addAddress(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-address-dialog.html').default,
      controller: function ($scope) {

        $scope.address = {};
        $scope.header = 'Add Address';
        $scope.save = 'Save';

        $scope.customAddressEnabled = false;

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onAddressChange = (address) => {
          $scope.address = address;
        }

        $scope.onLocationSelect = (location) => {
          if (!$scope.address) {
            $scope.address = {}
          }
          $scope.address.location = self.addressesService.getAddressLocation(location.lat, location.lng);
        }

        $scope.onToggleCustomAddress = () => {
          $scope.customAddressEnabled = !$scope.customAddressEnabled;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.address);
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editAddress(address, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-address-dialog.html').default,
      controller: function ($scope) {

        $scope.address = angular.copy(address);
        $scope.header = 'Update Address';
        $scope.save = 'Update';

        $scope.customAddressEnabled = false;

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onAddressChange = (address) => {
          $scope.address = address;
        }

        $scope.onLocationSelect = (location) => {
          if (!$scope.address) {
            $scope.address = {}
          }
          $scope.address.location = self.addressesService.getAddressLocation(location.lat, location.lng);
        }

        $scope.onToggleCustomAddress = () => {
          $scope.customAddressEnabled = !$scope.customAddressEnabled;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.address);
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  branchSelect(event, branchIds) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../../branches/views/dialogs/branches-select-dialog.html').default,
      controller: function ($scope) {

        const branchesRef = self.$branches();

        $scope.branchesList = {};
        $scope.selectedBranchId = undefined;
        $scope.loading = true;

        branchesRef.$getAll({isInactive: false})
          .then((allBranchIds) => {
            const branchIdsForSelection = _.difference(allBranchIds, branchIds);
            return branchesRef.$asyncValues(branchIdsForSelection);
          })
          .then((branchesList) => {
            $scope.branchesList = branchesList;
          })
          .catch((error) => {
            self.$log.error('Failed to get branches list @BranchesDialogService@branchesSelect', error);
          })
          .finally(() => {
            $scope.loading = false;
          });

        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid && $scope.selectedBranchId) {
              self.$mdDialog.hide($scope.selectedBranchId)
            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> BranchesDialogService@branchesSelect @submit')
          }

        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }


}

angular
  .module('bringoz.admin.customers')
  .service('' +
    'customersDialogService', CustomersDialogService);
